export const JOBS_SIDEBAR_ITEMS = [
  {
    label: 'Home',
    path: 'https://casting.com/',
  },
  {
    label: 'Casting',
    path: 'https://casting.com/casting/',
  },
  {
    label: 'Representatives',
    path: 'https://casting.com/representatives/',
  },
  {
    label: 'Talent',
    path: 'https://casting.com/talent',
  },
  {
    label: 'Job Noticeboard',
    path: '/',
  },
  {
    label: 'About',
    path: 'https://casting.com/about-2/',
  },
];
